import { QueryFactory } from '@lmt/shared-types';
import { Field } from '@lmt/unicorn-shared/app/components/common/Field';
import { FieldBlock } from '@lmt/unicorn-shared/app/components/common/FieldBlock';
import { CheckBox } from '@lmt/unicorn-shared/app/components/common/ui-kit/CheckBox';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC } from 'react';
import { HL7SettingsFormProps } from './types';
import styles from './../SettingsBlock.module.scss';
import { Input } from '../../../common/ui-kit/inputs/Input';

export const HL7IncomingSettingsBlock: FC<HL7SettingsFormProps> = (props) => {
  const i18next = useScopedTranslation('tenant_settings.hl7.incoming');

  const hl7IncomingSettingsQuery =
    QueryFactory.HL7IncomingSettingsQuery.useGetQuery();

  const { register } = props.form;

  const isHl7Enabled = hl7IncomingSettingsQuery.data?.enabled ?? false;
  const port = hl7IncomingSettingsQuery.data?.port ?? '';

  return (
    <div className={styles.blockContainer}>
      <FieldBlock
        title={i18next.t('incoming_settings')}
        className={styles.fieldBlock}
      >
        <div
          className={styles.row}
          data-test-id="incoming-transporter-checkbox"
        >
          {props.isServerEnabled && (
            <CheckBox
              disabled
              title={i18next.t('enabled')}
              checked={isHl7Enabled ?? false}
              className={styles.checkbox}
            />
          )}

          <CheckBox
            title={i18next.t('incoming_transporter_enabled')}
            className={styles.checkbox}
            {...register('incomingTransporterEnabled')}
          />
        </div>
        {props.isServerEnabled && (
          <Field title={i18next.t('port')} className={styles.field}>
            <Input variant="normal" disabled value={isHl7Enabled ? port : ''} />
          </Field>
        )}
      </FieldBlock>
    </div>
  );
};
